import React, { Component, useState } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import Select from "../common/form/select";

function UnidadeConsumidoraAguaForm(props) {
    const [state, setState] = useState({
        form: {
            id: props.dados.id || null,
            id_cliente: props.dados.id_cliente || null,
            id_unidade_consumidora: props.dados.id_unidade_consumidora || null,
            numero: props.dados.numero || null,
            id_concessionaria_agua: props.dados.id_concessionaria_agua || null,
            id_gestor_concessionaria_agua: props.dados.id_gestor_concessionaria_agua || null,
            usuario: props.dados.usuario || null,
            senha: props.dados.senha || null,
        },
    });

    return (
        <Form>
            <LabelAndInput
                name="numero"
                value={state.form.numero}
                label="Código da Matrícula"
                placeholder="Informe o código"
                cols="12 12 12 12"
                onChange={(e) => {
                    setState({
                        ...state,
                        form: {
                            ...state.form,
                            numero: e.target.value,
                        },
                    });
                }}
            />
            <Select
                name="id_concessionaria_agua"
                options={props.listaConcessionariaAgua}
                label="Concessionária de Água"
                cols="12 12 12 12"
                placeholder="Selecione a concessionaria"
                isClearable={true}
                value={state.form.id_concessionaria_agua}
                onChange={(data) => {
                    setState({
                        ...state,
                        form: {
                            ...state.form,
                            id_concessionaria_agua: data,
                        },
                    });
                }}
            />
            <Select
                name="id_gestor_concessionaria_agua"
                options={props.listaGestorConcessionaria.filter((gc) => gc.id_tipo_concessionaria == 2 && gc.id_concessionaria_agua == state.form.id_concessionaria_agua)}
                label="Gestor da Concessionária"
                cols="12 12 12 12"
                placeholder="Selecione o gestor da concessionaria"
                isClearable={true}
                value={state.form.id_gestor_concessionaria_agua}
                onChange={(data) => {
                    setState({
                        ...state,
                        form: {
                            ...state.form,
                            id_gestor_concessionaria_agua: data,
                        },
                    });
                }}
            />
            <LabelAndInput
                name="usuario"
                value={state.form.usuario}
                label="Login"
                placeholder="Informe o login"
                cols="12 12 12 12"
                onChange={(e) => {
                    setState({
                        ...state,
                        form: {
                            ...state.form,
                            usuario: e.target.value,
                        },
                    });
                }}
            />
            <LabelAndInput
                name="senha"
                value={state.form.senha}
                label="Senha"
                placeholder="Informe o senha"
                cols="12 12 12 12"
                onChange={(e) => {
                    setState({
                        ...state,
                        form: {
                            ...state.form,
                            senha: e.target.value,
                        },
                    });
                }}
            />

            <Row alignCenter={true} style={{ paddingBottom: 20 }}>
                <Grid cols="12 12 4 4" style={{ paddingTop: 5 }}>
                    <Button text="Salvar" type={"success"} event={() => props.handleSubmit({ registro: state.form, callback: props.handleCancel })} />
                </Grid>

                <Grid cols="12 12 4 4" style={{ paddingTop: 5 }}>
                    <Button text="Cancelar" type={"danger"} icon={"fa fa-times"} event={props.handleCancel} />
                </Grid>
            </Row>
        </Form>
    );
}

const mapStateToProps = (state) => ({
    listaConcessionariaAgua: state.cliente.listaConcessionariaAgua,
    listaGestorConcessionaria: state.gestorConcessionaria.listaGestorConcessionariaSelect,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeConsumidoraAguaForm);
